/**
 * Строку, выделенную стрелками, — в видимую часть списка. Прокручиваем только сам список:
 * scrollIntoView двигает и предков, вплоть до body с overflow: hidden, и у всплывашки над полем
 * ввода на низком экране съезжало бы всё приложение.
 */
export function revealIn(container: HTMLElement | null, el: HTMLElement | null): void {
  if (!container || !el) return
  const box = container.getBoundingClientRect()
  const row = el.getBoundingClientRect()
  if (row.top < box.top) container.scrollTop -= box.top - row.top
  else if (row.bottom > box.bottom) container.scrollTop += row.bottom - box.bottom
}
